package com.kinoshazam.uiKit.theme.colors

import androidx.compose.ui.graphics.Color

val DarkColorPalette = UiKitColors(
    color_1 = Color(0xFF1A9FDF),
    color_2 = Color(0xFFFFFFFF),
    color_3 = Color(0xFF020A24),
    color_4 = Color(0xFF222B49),
    color_5 = Color(0xFF000000),
    color_6 = Color(0xFFB4BBCC),
    color_7 = Color(0xFFFFFFFF),
    color_8 = Color(0xFFE6F4FF),
    color_9 = Color(0xFFEFF3F6),
    color_10 = Color(0xFFCBE8FF),
    color_11 = Color(0xFFB6CBDB),
    color_12 = Color(0xFF3996FF),
    color_13 = Color(0xFFF44336),
    color_14 = Color(0xFF20E87C),
    color_15 = Color(0xFFFFFFFF),
    color_16 = Color(0xFF9598B0),
    color_17 = Color(0xFF000000),
    color_18 = Color(0xFF181D24),
    color_19 = Color(0xFF262D35),
    color_20 = Color(0xFFDB3124),
    color_21 = Color(0xFF13CB68),
    color_22 = Color(0xFF8FDEFF),
    color_23 = Color(0xFF009FE3),
    color_24 = Color(0xFF3A3D42),
    color_25 = Color(0xFF3A6E95),
    colorOther_1 = Color(0xFFEA8590),
    colorOther_2 = Color(0xFFF0DD51),
    colorOther_3 = Color(0xFFFB9D6F),
    colorOther_4 = Color(0xFF6CCCB3),
    colorOther_5 = Color(0xFFE26EC0),
    colorOther_6 = Color(0xFF63ABDF),
    colorOther_7 = Color(0xFFAF95E9),
    colorOther_8 = Color(0xFFBED0D8),
    error = Color(0xFFF11111),
    transparent = Color(0xFFFFFFFF).copy(alpha = 0f),
    color_3_50 = Color(0xFF020A24),
    color_3_80 = Color(0xFF1B2942),
)